import { useTicketHooks as useTicketHooksGraphQL } from "@/features/tickets/hooks/ticket-hooks";
import { useEmployeeHooks as useEmployeeHooksGraphQL } from "@/lib/hooks/api/users/employee-graphql-hooks";
import { useTimeEntryHooks as useTimeEntryHooksGraphQL } from "@/lib/hooks/api/time-entries/time-entry-hooks";
import { useTaskHooks } from "./tasks-graphql";
import { useContactHooks } from "./contacts-graphql";
import { useCompanyHooks } from "./companies-graphql";
import { useSocialMediaPostHooks } from "./social-media-posts-graphql";
import { useEmailCampaignHooks } from "./email-campaigns-graphql";

import type { BaseEntity } from "@/components/shared/UniversalCRMTable/types";
import type { EntityHooks } from "@/components/shared/UniversalCRMTable/types/shared";

// Re-export hooks
export { useTaskHooks } from "./tasks-graphql";
export { useContactHooks } from "./contacts-graphql";
export { useCompanyHooks } from "./companies-graphql";
export { useSocialMediaPostHooks } from "./social-media-posts-graphql";
export { useEmailCampaignHooks } from "./email-campaigns-graphql";

// Placeholder exports for missing hooks
export const useUserHooks = () => ({});
export const useCommunicationHooks = () => ({});
export const useMspDocumentHooks = () => ({});

export function hasGraphQLHooks(entityName: string): boolean {
  const validEntities = [
    "tasks",
    "contacts",
    "tickets",
    "time_entries",
    "employees",
    "social_media_posts",
    "email_campaigns",
  ];
  return validEntities.includes(entityName);
}

export function getGraphQLHooks<T extends BaseEntity = BaseEntity>(
  entityName: string
): EntityHooks<T> | null {
  const hooksMap: Record<string, () => EntityHooks<BaseEntity>> = {
    tasks: useTaskHooks,
    contacts: useContactHooks,
    tickets: useTicketHooksGraphQL,
    time_entries: useTimeEntryHooksGraphQL,
    employees: useEmployeeHooksGraphQL,
    social_media_posts: useSocialMediaPostHooks,
    email_campaigns: useEmailCampaignHooks,
  };

  const hooks = hooksMap[entityName]?.();
  return hooks ? (hooks as unknown as EntityHooks<T>) : null;
}

// Legacy type exports for backward compatibility
export type { BaseEntity } from "@/components/shared/UniversalCRMTable/types/shared";
